import { makeStyles } from '@mui/styles';
import { useEffect } from 'react';
import { useContador } from '../../hooks/turns/useContador';

export const Contador = (props) => {

    const { fecha, estado, style } = props;
    const { contador, iniciarContador } = useContador(fecha, estado);
    const classes = useStyles();

    useEffect(() => {
        if(estado) {
            estado === 1 && iniciarContador();
            estado === 3 && iniciarContador();
        }
    }, [fecha]);
   
    return <div style={{ ...style }} className={classes.containerTime}>{ !estado ? fecha : contador }</div>
}

Contador.defaultProps = {
    estado: null,
    style: {}
}

const useStyles = makeStyles({
    containerTime: {
        display: 'flex',
        flexFlow: 'column'
    }
});